import { config } from '../../config';
import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import useApiStore from '../apiStore/useApiStore';
import { featureStore } from './featureStore';

const useFeatureStore = createStore({
  creator: featureStore({
    appName: config.unleash.appName,
    featureURL: config.unleash.url,
    useApiStore: lazyDependency(() => useApiStore),
  }),
  id: 'feature',
  middlewares: {
    devtools: true,
  },
});

export default useFeatureStore;
